

//// PROJECT MEDIA FILES - THUMBNAIL GRID WITH ACCORDIAN ////////////////////////////
//
// The project's media files, grouped the way they always were (this project
// first, then one accordion per project files were imported from) but rendered
// as a wall of preview cards instead of a 640px-wide table. Every action the
// rows carried - select, bulk delete, delete, unlink, favourite, download - is
// still here, on the card. Clicking a card opens the quick preview, which pages
// through the rest of that group.

import { makeStyles } from "@mui/styles";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, CircularProgress, IconButton, Typography } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useMemo, useState } from "react";
import { useEffect } from "react";
 
import "@fontsource/rubik";
import CustomTooltip from "./CustomTooltip";
import { downloadS3File, fileFormat, groupArrayByValue, isEditStarted, removeExtension, showSnackBar, sizeConverter, timeStampToNumberedDateString } from '../utils/commonServices'
import { deleteMedia, downloadMedia, favoriteMedia, markViewed } from '../services/api'
import { useMutation, useQuery } from "react-query";
import useUploadedList from "../hooks/useUploadedList"; 
 
import useSort from "../pages/events/hooks/useSort";
import useMediaDownload from "../pages/events/hooks/useMediaDownload";
import { updateState } from "../redux/commonSlice";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import usePermissions from "../hooks/usePermissions";
import { PERMISSION } from "../constants/constants";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import useBulkMediaDelete from "../hooks/useBulkMediaDelete";
import BulkDeleteMediaPopup from "../pages/events/components/BulkDeleteMediaPopup";
import { BULK_DELETE_MAX_BATCH, isCleanBulkDeleteResult } from "../utils/bulkMediaDelete";
import useCustomTheme from "../theme/useCustomTheme";
import MediaQuickPreview from "./media/MediaQuickPreview";
import MediaRowThumbnail from "./media/MediaRowThumbnail";
import { MOBILE, ROW_THUMB_WIDTH, ROW_THUMB_WIDTH_MOBILE } from "./media/mediaConstants";

// The server gave up processing the file (`processing_error` set, no URL), so it
// will never become previewable or downloadable - unlike a file still processing.
// Re-uploading is only an option while the project still takes uploads.
const processingFailedText = (canUpload) => (canUpload ? 'Processing failed - please upload again' : 'Processing failed - contact support');
const processingFailed = (file) => !!file?.processing_error && (file?.video_url == null || file?.video_url == '');


// A file that has not been viewed yet used to be flagged by a green dot in front
// of its name. The name itself now carries that, in a green dark enough to stay
// legible at the sizes the name is set in - which pure #00FF00 is not.
const UNVIEWED_NAME_COLOR = '#00A63E';

// Space between the preview tile and the file name beside it. Shared by the
// rows and by the header's spacer cell, so the columns stay lined up.
const THUMB_GAP = { xs: '10px', md: '14px', lg: '16px', xl: '22px' };

const useStyles = makeStyles((theme) => ({
  container: {
      width:'100%',
      borderCollapse: 'collapse',
     // paddingRight:'4%'
     scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
               display : 'none'
             }
  },
  tableHead:{
      marginBottom:'10px',
      height:'28.5px',
      fontFamily: "Rubik",
  },
  tableRowData:{
      borderBottom:'2px solid #EBEBEB',
      backgroundColor:'transparent',
      fontFamily: "Rubik",
      textAlign:'left',
      width:'100%',
      fontSize:'15px',
      fontWeight:600,
      color:'#08231B',
      letterSpacing: '0.75px',
      zIndex: 15,
      '&:last-child':{
        borderBottom:'none'
      }
  },
  tableCell:{
      textAlign:'right'
  },
}));




const CustomVideoTable = (props) => {

  const {progressFlag=true, files, isUploading, progress, stopUpload, uploadStatus, uploadedVideosArray=[],sortBy, importFiles, setUploadedVideosArray, importFilesStatus, refetch} = props;
  const classes = useStyles();
  const [enableDownload, setEnableDownload] = useState(false)
  const [payload, setPayload] = useState({id:''})
  const commonReducer = useSelector((state) => state.root.commonReducer);
  // const [tempUploadedVideoArray, setTempUploadedVideoArray] = useState(uploadedVideosArray)
  // The quick preview walks a list. It keeps the ids rather than a snapshot of
  // the files, and resolves them against the live list on every render - so a
  // file favourited or deleted from inside the dialog is reflected there
  // immediately once the refetch lands, with no second copy to keep in step.
  const [previewIds, setPreviewIds] = useState([])
  const [previewIndex, setPreviewIndex] = useState(0)
  // Which group the dialog was opened from, since own and imported media carry
  // different permissions and a different remove action.
  const [previewScope, setPreviewScope] = useState('self')
  // const [favorite, setFavorite] = useState({id:'', favorite: null})
  //uploadedVideoList, refetchUploadList, uploadListStatus, uploadListLoading, enableGetUploadedMediaFiles]
  const {uploadedVideoList : uploadedVideos, refetchUploadList : refetchList, uploadListLoading : uploadedListLoading, uploadListStatus} = useUploadedList(commonReducer.is_logged);
  const dispatch = useDispatch();
  const [downloadMedia] = useMediaDownload();
  const [reversedArray, setReversedArray] = useState(uploadedVideosArray)
  const [sortedFiles] = useSort( reversedArray, sortBy)
  const [importedFiles, setImportedFiles] = useState([])
  const [fileId, setFileId] = useState(null)
  const [clickType, setClickType] = useState("")
  const [isMainAccordianExpanded, setIsMainAccordianExpanded] = useState(true)
  const [hasPermission] = usePermissions()
  const [selectedFileIds, setSelectedFileIds] = useState([])
  const [bulkDeletePopupOpen, setBulkDeletePopupOpen] = useState(false)
  const [theme] = useCustomTheme()


//  console.log({tempUploadedVideoArray, uploadedVideosArray})

const {
  data: downloadData,
  error: downloadError,
  isLoading
} = useQuery(
  [`download${payload}`, payload],
  () => downloadMedia(payload),
  { enabled: enableDownload, retry: false }
);

//POST API Request  favorite video
const { mutate: addFavoriteMediaMutate, isLoading: addFavoriteMediaLoading } =
  useMutation(favoriteMedia, {
    onSuccess: (response, variables, context) =>
      favoriteMediaSuccessHandler(response, variables, context),
    onError: (error, variables, context) =>
      favoriteMediaErrorHandler(error, variables, context),
  });

const  favoriteMediaSuccessHandler = (response, variables, context) => {
  const responseObject = response?.data;
  const responseData = responseObject?.data
  if (responseObject?.http_code == 200) {
  //   dispatch(updateState({ production_event_id: responseData?.id }));
  //   showSnackbar(responseObject);
  //   setCreateEventStatus("success");
  // setUploadedVideosArray((prev)=>prev.map(file=>{
  //   if(file?.id == fileId){
  //     return {...file, favourite: !file?.favourite}
  //   }else{
  //     return file
  //   }
  // }))
  refetchList()

  }

};

const favoriteMediaErrorHandler = (error, variables, context) => {
  // setSubmitFlag(false);
  // setCreateEventStatus("error");
  const errorObject = error?.response?.data;
  showSnackBar(dispatch, errorObject);

};

//PUT API Request  to mark viewed video
const { mutate: markViewedMutate, isLoading: markViewedLoading } =
  useMutation(markViewed, {
    onSuccess: (response, variables, context) =>
      markViewedSuccessHandler(response, variables, context),
    onError: (error, variables, context) =>
      markViewedErrorHandler(error, variables, context),
  });

// `viewed` is the only thing this call changes, and the only thing the list
// renders off it is the file name's weight and colour. Refetching the whole
// media list for that put the list into its loading state every time a preview
// opened, which disabled the dialog's own delete and favourite buttons for a
// moment just as the user reached for them. Patch the one flag locally instead;
// the next real refetch brings the server's copy, which agrees.
const  markViewedSuccessHandler = (response, variables, context) => {
  const responseObject = response?.data;
  if (responseObject?.http_code == 200 && variables?.id != null) {
    setReversedArray((prev)=> prev?.map(item => item?.id == variables.id ? {...item, viewed: true} : item))
  }

};


//console.log("uploadstatus", uploadListLoading)



const markViewedErrorHandler = (error, variables, context) => {
  // setSubmitFlag(false);
  // setCreateEventStatus("error");
  const errorObject = error?.response?.data;

};


  // Files that belong to this project — the only ones the bulk endpoint is
  // offered for. Imported files are unlinked, not deleted, so they stay out.
  const ownProjectFiles = useMemo(
    () => sortedFiles?.filter(video => video.event_name == commonReducer.event_details?.name) || [],
    [sortedFiles, commonReducer.event_details?.name]
  )

  const canBulkDelete = hasPermission(PERMISSION.PROJECT.MEDIA.DELETE.SELF) && commonReducer.event_details?.status_type_order < 3

  //BULK DELETE API Request  videos
  const {
    startBulkDelete,
    retryBulkDelete,
    resetBulkDelete,
    bulkDeleteStatus,
    bulkDeleteResult,
    bulkDeleteQueuedBatch,
    bulkDeleteError,
    bulkDeleteFileNames,
    isBulkDeleting
  } = useBulkMediaDelete((deletedIds, result) => {
    setSelectedFileIds((prev) => prev.filter(id => !deletedIds.includes(id)))
    refetchList()
    // Nothing left to read when every file went through — close and let the
    // snackbar report it. A batch with failures keeps the popup open so the
    // per-file reasons stay on screen until the user dismisses them.
    if (isCleanBulkDeleteResult(result)) {
      setBulkDeletePopupOpen(false)
    }
  })

  const isFileSelected = (id) => selectedFileIds.includes(id)

  // Handed to the delete hook so a failure the backend refuses to name - it
  // withholds filenames the caller may not see - can still be listed by the name
  // the user selected it under. BMD-01/BMD-04.
  const selectedFiles = ownProjectFiles.filter(file => selectedFileIds.includes(file?.id))

  const toggleFileSelection = useCallback((id) => {
    setSelectedFileIds((prev) => prev.includes(id) ? prev.filter(selectedId => selectedId != id) : [...prev, id])
  }, [])

  // Capped at the backend's MAX_BATCH so the cap never arrives as a surprise 422.
  const selectableFileIds = ownProjectFiles.map(file => file?.id).slice(0, BULK_DELETE_MAX_BATCH)

  const allFilesSelected = selectableFileIds.length > 0 && selectableFileIds.every(id => selectedFileIds.includes(id))

  const someFilesSelected = selectedFileIds.length > 0 && !allFilesSelected

  const handleSelectAllChange = (e) => {
    setSelectedFileIds(e.target.checked ? selectableFileIds : [])
  }

  const bulkDeleteClickHandler = () => {
    resetBulkDelete()
    setBulkDeletePopupOpen(true)
  }

  const bulkDeletePopupCloseHandler = () => {
    setBulkDeletePopupOpen(false)
    resetBulkDelete()
  }

  //DELETE API Request   video
  const { mutate: deleteMediaMutate, isLoading: deleteMediaLoading } =
  useMutation(deleteMedia, {
    onSuccess: (response, variables, context) =>
      deleteMediaSuccessHandler(response, variables, context),
    onError: (error, variables, context) =>
      deleteMediaErrorHandler(error, variables, context),
  });

const  deleteMediaSuccessHandler = (response, variables, context) => {
  const responseObject = response?.data;
  const responseData = responseObject?.data
  if (responseObject?.http_code == 200) {
  //   dispatch(updateState({ production_event_id: responseData?.id }));
  //   showSnackbar(responseObject);
  //   setCreateEventStatus("success");
  refetchList()
  } else {
    // The delete endpoint answers HTTP 200 even when it has refused the delete -
    // the real status is in the body. Without this the row simply stays put and
    // the user is told nothing, which reads as the click having been missed.
    showSnackBar(dispatch, responseObject);
  }

};

const deleteMediaErrorHandler = (error, variables, context) => {
  // setSubmitFlag(false);
  // setCreateEventStatus("error");
  const errorObject = error?.response?.data;
  showSnackBar(dispatch, errorObject);
};


  // The grid hands whole file objects to its cards, and the cards are memoised,
  // so every handler below is referentially stable across a re-render.
  const favoriteHandler = useCallback((file, e)=>{
      setClickType("fvt")
      setFileId(file?.id)
      addFavoriteMediaMutate({id:file?.id ,event_id: commonReducer.production_event_id, favourite: !file?.favourite })   
  }, [addFavoriteMediaMutate, commonReducer.production_event_id])

  const handleDelete = useCallback((file) => {
    setClickType("dlt")
       setFileId(file?.id)
       deleteMediaMutate({id: file?.id})
      // refetchList()
    }, [deleteMediaMutate]);

  const removeLinkedFileHandler = useCallback(async (file)=>{
    setClickType("dlt")
    setFileId(file?.id)
    await importFiles({destination_event_id: commonReducer.production_event_id, media_files: JSON.stringify([{id: file?.id, checked: false}])})
    
    // refetchList();
  }, [importFiles, commonReducer.production_event_id])

    const videoDownloadHandler = useCallback((file)=>{
      if(file?.video_url != null && file?.video_url != "") {
        downloadS3File(file.download_link)
      }
     
     // console.log('Video download')// download video 
      // const url = 'https://s3.us-central-1.wasabisys.com/files-storage-staging/final_video/2/wasabi_sample.mp4';
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', 'video.mp4');
      // link.target = '_blank';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);  
  }, [])
  // Opens the quick preview on `file`, paging over the other previewable files
  // in the same group so next/previous walks that project's uploads.
  const openPreviewHandler = (group, scope) => (file) => {
      if(file?.video_url == null || file?.video_url == "") return

      const playableFiles = group?.filter(item => item?.video_url != null && item?.video_url != "") || []
      const startIndex = playableFiles.findIndex(item => item?.id == file?.id)
      if(startIndex < 0) return

      if(!file?.viewed) markViewedMutate({id: file?.id})
      setPreviewIds(playableFiles.map(item => item?.id))
      setPreviewIndex(startIndex)
      setPreviewScope(scope)
      dispatch(updateState({open_media_preview: true}))
  }

  // The files behind the ids the dialog is paging through, in that order. A file
  // that has been deleted simply stops resolving and drops out of the set.
  const previewFiles = useMemo(() => {
      const byId = new Map((reversedArray || []).map(item => [item?.id, item]))
      return previewIds.map(id => byId.get(id)).filter(Boolean)
  }, [previewIds, reversedArray])

  const previewFile = previewFiles[previewIndex]

  // Paging counts as viewing, same as opening a file did on the old table.
  const previewNavigateHandler = (nextIndex)=> {
      const nextFile = previewFiles[nextIndex]
      if(!nextFile) return
      setPreviewIndex(nextIndex)
      if(!nextFile?.viewed) markViewedMutate({id: nextFile?.id})
  }

  const previewCloseHandler = useCallback(()=> {
      dispatch(updateState({open_media_preview: false}))
      setPreviewIds([])
      setPreviewIndex(0)
  }, [dispatch])

  // Deleting the file on screen leaves a hole in the set. Keeping the index put
  // slides the next file into view; past the end it steps back, and with nothing
  // left the dialog closes itself.
  useEffect(()=> {
      if(commonReducer.open_media_preview != true || previewIds.length == 0) return
      if(previewFiles.length == 0) {
        previewCloseHandler()
      } else if (previewIndex > previewFiles.length - 1) {
        setPreviewIndex(previewFiles.length - 1)
      }
  }, [previewFiles, previewIndex, previewIds, commonReducer.open_media_preview, previewCloseHandler])
  

  useEffect(() => {
   
    let tempArr = [...uploadedVideosArray].reverse().map(element => {
      return element;
    });
    //console.log({tempArr})
    setReversedArray(tempArr)
    // setTempUploadedVideoArray(uploadedVideosArray)
    // console.log(tempArray)

  }, [uploadedVideosArray])

  useEffect(()=> {
    const visibleIds = (uploadedVideosArray || []).map(file => file?.id)
    setSelectedFileIds((prev) => prev.filter(id => visibleIds.includes(id)))
  }, [uploadedVideosArray])

  useEffect(()=> {
    const tempArray = groupArrayByValue(sortedFiles?.filter(video => video.event_name != commonReducer.event_details?.name), 'event_name')
    setImportedFiles(tempArray)
   // console.log({tempArray})

  }, [reversedArray])

  // useEffect(()=> {
  //   if(importFilesStatus === 'success') {
  //     console.log("sdsd")
  //     refetch()
  //   }
  // }, [importFilesStatus])

 
  

  const actionsDisabled = commonReducer.is_media_loading == true || deleteMediaLoading == true || addFavoriteMediaLoading == true || isBulkDeleting

  const isRowDeleting = (file, importedRow = false) =>
    ((commonReducer.is_media_loading == true && clickType == 'dlt') || (importedRow ? importFilesStatus == 'loading' : deleteMediaLoading == true)) && fileId == file?.id

  const isRowFavoriting = (file) =>
    ((commonReducer.is_media_loading == true && clickType == 'fvt') || addFavoriteMediaLoading == true) && fileId == file?.id

  // Delete and favourite are only offered while the project is still accepting
  // media, exactly as the table rows did.
  const projectEditable = commonReducer.event_details?.status_type_order < 3
  // Same rule the project page uses to show its upload box.
  const canReupload = projectEditable && !isEditStarted(commonReducer.event_details?.editor_start_date)

  const emptyStateText = commonReducer.event_details?.status_type_order > 2 ? "No media file to show" : "Start uploading files to your Project."

  const openOwnPreview = openPreviewHandler(ownProjectFiles, 'self')

return (
  <Box pr={0.5}>
    {canBulkDelete && <Box sx={{display:'flex', alignItems:'center', justifyContent:'flex-end', minHeight:{xs:'24px',md:'28px',xl:'38px'}}} gap={1} pb={0.5}>
      {selectedFileIds.length > 0 && <>
        <Typography sx={{fontSize: {xs:'9px',md:'10px',lg:'12px',xl:'17px'}, fontFamily: 'Rubik', color:'#4f635d', [MOBILE]:{fontSize:'13px'}}}>
          {`${selectedFileIds.length} selected`}
        </Typography>
        <Button
          variant="text"
          onClick={()=>setSelectedFileIds([])}
          disabled={isBulkDeleting}
          sx={{fontSize: {xs:'8px',md:'9px',lg:'10px',xl:'15px'}, fontFamily: 'Rubik', textTransform:'none', textDecoration:'underline', minWidth:0, padding:0, [MOBILE]:{fontSize:'13px'}}}
        >
          Clear
        </Button>
        <CustomTooltip title={`Delete ${selectedFileIds.length} selected ${selectedFileIds.length === 1 ? 'file' : 'files'}`}>
          <span>
            <Button
              variant="contained"
              onClick={bulkDeleteClickHandler}
              disabled={isBulkDeleting || commonReducer.is_media_loading == true || deleteMediaLoading == true}
              sx={{
                fontSize: {xs:'8px',md:'9px',lg:'10px',xl:'15px'},
                fontFamily: 'Rubik',
                textTransform:'none',
                paddingY:{xs:0.2,xl:0.6},
                backgroundColor: '#08231B',
                color: theme.palette.primary.main,
                '&:hover': { backgroundColor: '#08231B' },
                '&.Mui-disabled': { backgroundColor: '#08231B60', color: `${theme.palette.primary.main}80` },
                [MOBILE]: { fontSize:'13px', minHeight:'40px', paddingX:'16px' }
              }}
            >
              Delete Selected
            </Button>
          </span>
        </CustomTooltip>
      </>}
    </Box>}

    <Box sx={{ display:'flex'}} className={classes.tableHead}>
      {canBulkDelete && <Box sx={{width:{xs:'22px',md:'26px',lg:'30px',xl:'40px'}, flexShrink:0, display:'flex', alignItems:'center'}}>
        <CustomTooltip title={allFilesSelected ? 'Clear selection' : 'Select all files in this project'}>
          <Checkbox
            size='small'
            sx={{padding:0, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'16px',xl:'22px'}}, zIndex:0}}
            onChange={handleSelectAllChange}
            checked={allFilesSelected}
            indeterminate={someFilesSelected}
            disabled={selectableFileIds.length === 0 || isBulkDeleting}
            checkedIcon={<CheckBoxOutlinedIcon/>}
            inputProps={{'aria-label':'Select all files in this project'}}
          />
        </CustomTooltip>
      </Box>}
      <Box sx={{width: ROW_THUMB_WIDTH, flexShrink:0, marginRight:THUMB_GAP, [MOBILE]:{width:ROW_THUMB_WIDTH_MOBILE, marginRight:'14px'}}} />
      <Box flex={6} style={{maxWidth:'220px', whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", paddingRight: 24,  minWidth:'220px'}}><Typography  sx={{fontSize: {xs:'9px',md:'10px',lg:'12px',xl:'17px'}, fontFamily: 'Rubik' ,fontWeight:600,color:'#4f635d'}}>File Name</Typography></Box>

      {/* File Type now rides in the corner of the row's thumbnail. Kept here,
          commented, in case the column is wanted back. */}
      {/* <Box flex={0.7} style={{  minWidth:'90px', }}><Typography textAlign='center' sx={{fontSize: {xs:'9px',md:'10px',lg:'12px',xl:'17px'},  fontFamily: 'Rubik' ,fontWeight:600,color:'#4f635d'}}>File Type</Typography></Box> */}

      {/* Size reads under the file name now. Kept here, commented, in case the
          column is wanted back. */}
      {/* <Box flex={0.7} style={{  minWidth:'60px', }}><Typography textAlign='center' sx={{fontSize: {xs:'9px',md:'10px',lg:'12px',xl:'17px'}, fontFamily: 'Rubik',fontWeight:600 ,color:'#4f635d' }}>Size</Typography></Box> */}

      <Box flex={0.7} style={{  minWidth:'70px', }}><Typography textAlign='center' sx={{fontSize: {xs:'9px',md:'10px',lg:'12px',xl:'17px'}, fontFamily: 'Rubik',fontWeight:600,color:'#4f635d'}}>Upload Date</Typography></Box>

      <Box flex={1}  style={{  minWidth:'60px',maxWidth:'150px'}}><Typography textAlign='center' sx={{fontSize: {xs:'9px',md:'10px',lg:'12px',xl:'17px'}, fontFamily: 'Rubik', fontWeight:600,color:'#4f635d'}}>Uploaded By</Typography></Box>

      <Box flex={1}  className={classes.tableCell} ><Typography  sx={{fontSize: {xs:'9px',md:'10px',lg:'12px',xl:'17px'}, fontFamily: 'Rubik', fontWeight:600,color:'#4f635d'}}>{files?.length > 0 && "Status"}</Typography></Box>
    </Box>

    <Box className={classes.container} 
      component = 'div'
      sx={{
          overflowY: 'scroll',
          height: {xs:'35vh',sm:'35vh',md: '37vh',lg:'39vh', xl: '48vh'}, 
          minHeight:'300px'
      }}
    >
      {
        uploadedListLoading == true ? 
          <Typography px={15} sx={{color:'#878887', fontSize:{xs:'20px',sm:'24px',md:'28px',lg:'33.33px',xl:'50px'}, fontWeight: 300, fontFamily: "Rubik", textAlign: 'center', marginTop:'4%', marginBottom:'1%', [MOBILE]:{fontSize:'18px', paddingX:'20px'}}} variant="h3">Loading...</Typography>
          : uploadListStatus == 'error' ?
          <Typography role="alert" px={15} sx={{color:'#878887', fontSize:{xs:'16px',sm:'18px',md:'20px',lg:'24px',xl:'34px'}, fontWeight: 300, fontFamily: "Rubik", textAlign: 'center', marginTop:'4%', marginBottom:'1%', [MOBILE]:{fontSize:'16px', paddingX:'20px'}}} variant="h3">We couldn't load your media files. Please try again.</Typography>
          : <> 
         {hasPermission(PERMISSION.PROJECT.MEDIA.VIEW.SELF) && <Accordion defaultExpanded={true} style={{backgroundColor:'transparent'}} disableGutters={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
            >
                <Typography sx={{fontSize: {xs:'10px',md:'12px',lg:'13px',xl:'20px'}, fontFamily: 'Rubik' , color:'#08231B', [MOBILE]:{fontSize:'15px'}}}>{commonReducer.event_details?.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box sx={{width:'100%', textAlign:'center', display:'grid', placeContent:'center', }} >
                   {(ownProjectFiles?.length == 0 && files?.length == 0 ) && <Typography px={15} sx={{color:'#878887', fontSize:{xs:'20px',sm:'24px',md:'28px',lg:'33.33px',xl:'50px'}, fontWeight: 300, fontFamily: "Rubik", marginTop:'2%', marginBottom:'2%', [MOBILE]:{fontSize:'16px', paddingX:'20px'}}} variant="h3">{emptyStateText}</Typography>}
                </Box>

              {ownProjectFiles?.length > 0 && ownProjectFiles?.map((file, index) => (
                <Box className={classes.tableRowData} key={file?.size + index} sx={{display:'flex',  alignItems:'center', height:{xs:'48px',sm:'52px',md:'56px',lg:'64px',xl:'82px'}, [MOBILE]:{height:'60px'}}}>
               {canBulkDelete && <Box sx={{width:{xs:'22px',md:'26px',lg:'30px',xl:'40px'}, flexShrink:0, display:'flex', alignItems:'center'}}>
                 <Checkbox
                   size='small'
                   sx={{padding:0, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'16px',xl:'22px'}}, zIndex:0}}
                   checked={isFileSelected(file?.id)}
                   onChange={()=>toggleFileSelection(file?.id)}
                   disabled={isBulkDeleting || deleteMediaLoading == true}
                   checkedIcon={<CheckBoxOutlinedIcon/>}
                   inputProps={{'aria-label':`Select ${file?.name}`}}
                 />
               </Box>}
               <Box sx={{marginRight:THUMB_GAP, [MOBILE]:{marginRight:'14px'}}}>
                 <MediaRowThumbnail
                   file={file}
                   canPreview={hasPermission(PERMISSION.PROJECT.MEDIA.PLAYBACK.SELF)}
                   onPreview={openOwnPreview}
                 />
               </Box>
                    {/* Name on top, with the type and size it used to take two
                        columns to say reading underneath it. */}
                    <Box flex={6} sx={{maxWidth:'220px', minWidth:'220px', paddingRight:'24px', display:'flex', flexDirection:'column', justifyContent:'center', minHeight:0}}>
                      <CustomTooltip title = {file?.name} >
                        <Typography onClick={()=>hasPermission(PERMISSION.PROJECT.MEDIA.PLAYBACK.SELF) && openOwnPreview(file)}  sx={{fontSize: {xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight: file.viewed ? 500 : 900, color: file.viewed ? undefined : UNVIEWED_NAME_COLOR, fontFamily: 'Rubik', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', [MOBILE]:{fontSize:'13px'}, cursor: (file?.video_url != null && file?.video_url != "") && 'pointer'}}>{removeExtension(file?.name)}</Typography>
                      </CustomTooltip>
                      <Typography sx={{fontSize: {xs:'7px',md:'9px',lg:'10px',xl:'14px'}, fontWeight:400, fontFamily: 'Rubik', color: processingFailed(file) ? '#CE0101' : '#4f635d', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', [MOBILE]:{fontSize:'11px'}}}>{processingFailed(file) ? processingFailedText(canReupload) : `${fileFormat(file?.name)?.toUpperCase()} · ${sizeConverter(parseInt(file?.size))}`}</Typography>
                    </Box>

                    {/* File Type - shown on the thumbnail instead. */}
                    {/* <Box flex={0.7} style={{  minWidth:'90px'}}> <Typography textAlign='center' sx={{fontSize:{xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight:file.viewed ? 500 : 900,  fontFamily: 'Rubik' }}>{fileFormat(file?.name)}</Typography></Box> */}

                    {/* Size - shown under the file name instead. */}
                    {/* <Box flex={0.7} style={{  minWidth:'60px'}}> <Typography textAlign='center' sx={{fontSize: {xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight:file.viewed ? 500 : 900, fontFamily: 'Rubik'}}>{sizeConverter(parseInt(file?.size))}</Typography></Box> */}
              

                    <Box flex={0.7}  className='flex j-center'  style={{ minWidth:'70px'}}><Typography textAlign='center' sx={{fontSize: {xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight:file.viewed ? 500 : 900, fontFamily: 'Rubik'}}>{timeStampToNumberedDateString(file?.upload_time)}</Typography></Box>

                 <CustomTooltip title = { file?.uploaded_by} >
                    <Box flex={1} className='flex' style={{minWidth:'60px',    maxWidth:'150px',whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}><Typography textAlign='center' sx={{fontSize: {xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight:file.viewed ? 500 : 900, fontFamily: 'Rubik'}}>{file?.uploaded_by}</Typography></Box>
                  </CustomTooltip>

                    <Box flex={1}  sx={{ display:'flex', justifyContent:'end'}} className={classes.tableCell}><Box  sx={{fontSize: {xs:'8px',md:'10px',lg:'12px',xl:'16px'}, display:'flex', alignItems:'center',justifyContent:'end' }} gap={0.5}>
                  { commonReducer.event_details?.status_type_order < 3 &&
                       <> {((commonReducer.is_media_loading == true && clickType == 'dlt') || deleteMediaLoading == true) && fileId == file.id ?(
                              <CircularProgress    
                                sx={{
                                  height:'4px', width:'4px',
                                  margin:{xs:0.75,md:0.87,lg:1.1, xl:1.4},
                                  color:'#666'
                                  }}
                                size={14}
                                loading={(commonReducer.is_media_loading == true && clickType == 'dlt') || deleteMediaLoading == true}
                                disabled 
                              >    
                              </CircularProgress>
                             ):(
                           
                        hasPermission(PERMISSION.PROJECT.MEDIA.DELETE.SELF) && <IconButton  
                            aria-label={`Delete ${file?.name}`}
                            disabled = {commonReducer.is_media_loading == true || deleteMediaLoading == true || addFavoriteMediaLoading == true || isBulkDeleting }
                            onClick={()=>handleDelete(file)} sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},
                           }}}>
                            <DeleteIcon  sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},
                           }}}/>
                         </IconButton> 
                             )
                       }
                  
                             
                             {((commonReducer.is_media_loading == true && clickType == 'fvt')|| addFavoriteMediaLoading == true) && fileId == file.id ?(
                              <CircularProgress    
                                sx={{
                                  height:'4px', width:'4px',
                                  margin:{xs:0.75,md:0.87,lg:1.1, xl:1.4},
                                  color:'#666'
                                  }}
                                size={14}
                                loading={(commonReducer.is_media_loading == true && clickType == 'fvt') || addFavoriteMediaLoading == true}
                                disabled
                              >    
                              </CircularProgress>
                             ):(
                           
                          hasPermission(PERMISSION.PROJECT.MEDIA.FAVORITE.SELF) && <Checkbox 
                           sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'}},  zIndex:0}} 
                          //  onClick={()=>favoriteHandler(file)} 
                          onChange={(e)=>favoriteHandler(file, e)}
                           inputProps={{'aria-label':`${file?.favourite ? 'Unfavorite' : 'Favorite'} ${file?.name}`}}
                           checked={file?.favourite}  
                           disabled = {commonReducer.is_media_loading == true || deleteMediaLoading == true || addFavoriteMediaLoading == true || isBulkDeleting }
                           icon={<StarOutlineIcon sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'},  '& .MuiSvgIcon-root':{
                            fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},
                           }}}/>} 
                           checkedIcon={<StarIcon sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},
                           } }}/>} 

                           />
                             )}
                           
                           </>
                               }
                          <CustomTooltip title= {processingFailed(file) ? processingFailedText(canReupload) : (file?.video_url == null || file?.video_url == "") ? "Will be available for download after some time" : "Download"} >
                            {hasPermission(PERMISSION.PROJECT.MEDIA.DOWNLOAD.SELF) && <IconButton 
                              aria-label={`Download ${file?.name}`}
                              disabled={file?.video_url == null || file?.video_url == "" || commonReducer.is_media_loading == true || deleteMediaLoading == true || addFavoriteMediaLoading == true || isBulkDeleting }  
                              onClick={()=>videoDownloadHandler(file)} 
                              sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, 
                                  '& .MuiSvgIcon-root':{fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},}}} 
                            >
                              <FileDownloadOutlinedIcon  sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'},  '& .MuiSvgIcon-root':{fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},}}}/>
                            </IconButton>}
                          </CustomTooltip>
                    </Box></Box>
               </Box>
               ))}


                </AccordionDetails>
               </Accordion>}

               { hasPermission(PERMISSION.PROJECT.MEDIA.VIEW.IMPORTED) && importedFiles.map((project, index)=> {
                // One preview opener per group, so the memoised cards below keep
                // the same callback identity between renders.
                const openImportedPreview = openPreviewHandler(project, 'imported')
                return (
                <Accordion key={project[0]?.event_name || index} style={{backgroundColor:'transparent'}} disableGutters={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`imported-panel-${index}-content`}
                  id={`imported-panel-${index}-header`}
                >
                  <Typography  sx={{fontSize:  {xs:'10px',md:'12px',lg:'13px',xl:'20px'}, fontFamily: 'Rubik' , color:'#08231B', textTransform:'capitalize', [MOBILE]:{fontSize:'15px'}}}>{project[0].event_name}</Typography>
                </AccordionSummary>
                <AccordionDetails >
                {project.map(file =>(
              <Box className={classes.tableRowData} key={file?.size} sx={{display:'flex',  alignItems:'center', height:{xs:'48px',sm:'52px',md:'56px',lg:'64px',xl:'82px'}, [MOBILE]:{height:'60px'}}}>
                {canBulkDelete && <Box sx={{width:{xs:'22px',md:'26px',lg:'30px',xl:'40px'}, flexShrink:0, display:'flex', alignItems:'center'}}></Box>}
                <Box sx={{marginRight:THUMB_GAP, [MOBILE]:{marginRight:'14px'}}}>
                  <MediaRowThumbnail
                    file={file}
                    canPreview={hasPermission(PERMISSION.PROJECT.MEDIA.PLAYBACK.IMPORTED)}
                    onPreview={openImportedPreview}
                  />
                </Box>
                    <Box flex={6} sx={{maxWidth:'220px', minWidth:'220px', paddingRight:'24px', display:'flex', flexDirection:'column', justifyContent:'center', minHeight:0}}>
                      <CustomTooltip title = {file?.name} >
                        <Typography onClick={()=>hasPermission(PERMISSION.PROJECT.MEDIA.PLAYBACK.IMPORTED) && openImportedPreview(file)}  sx={{fontSize: {xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight:500, fontFamily: 'Rubik', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', [MOBILE]:{fontSize:'13px'}, cursor: (file?.video_url != null && file?.video_url != "") && 'pointer'}}>{removeExtension(file?.name)}</Typography>
                      </CustomTooltip>
                      <Typography sx={{fontSize: {xs:'7px',md:'9px',lg:'10px',xl:'14px'}, fontWeight:400, fontFamily: 'Rubik', color: processingFailed(file) ? '#CE0101' : '#4f635d', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', [MOBILE]:{fontSize:'11px'}}}>{processingFailed(file) ? processingFailedText(canReupload) : `${fileFormat(file?.name)?.toUpperCase()} · ${sizeConverter(parseInt(file?.size))}`}</Typography>
                    </Box>

                    {/* File Type - shown on the thumbnail instead. */}
                    {/* <Box flex={0.7} style={{  minWidth:'90px'}}> <Typography textAlign='center' sx={{fontSize: {xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight:500, fontFamily: 'Rubik' }}>{fileFormat(file?.name)}</Typography></Box> */}

                    {/* Size - shown under the file name instead. */}
                    {/* <Box flex={0.7} style={{  minWidth:'60px'}}> <Typography textAlign='center' sx={{fontSize:{xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight:500, fontFamily: 'Rubik'}}>{sizeConverter(parseInt(file?.size))}</Typography></Box> */} 
              

                    <Box flex={0.7}  className='flex j-center'  style={{ minWidth:'70px'}}><Typography textAlign='center' sx={{fontSize:{xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight:500, fontFamily: 'Rubik'}}>{timeStampToNumberedDateString(file?.upload_time)}</Typography></Box>

                    <Box flex={0.7} className='flex j-center' style={{ minWidth:'60px'}}><Typography textAlign='center' sx={{fontSize: {xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight:500, fontFamily: 'Rubik'}}>{file?.uploaded_by}</Typography></Box>

              

                    <Box flex={1}  sx={{ display:'flex', justifyContent:'end'}} className={classes.tableCell}><Box  sx={{fontSize: {xs:'8px',md:'9px',lg:'10px',xl:'14px'}, display:'flex', alignItems:'center',justifyContent:'end' }} gap={0.5}>
                  { commonReducer.event_details?.status_type_order < 3 &&
                       <>  
                       {((commonReducer.is_media_loading == true && clickType == 'dlt') || importFilesStatus == 'loading') && fileId == file.id ?(
                              <CircularProgress    
                                sx={{
                                  height:'4px', width:'4px',
                                  margin:{xs:0.75,md:0.87,lg:1.1, xl:1.4},
                                  color:'#666'
                                  }}
                                size={14}
                                loading={(commonReducer.is_media_loading == true && clickType == 'dlt') || importFilesStatus == 'loading'}
                                disabled
                              >    
                              </CircularProgress>
                             ):(
                           
                            <CustomTooltip title='Remove this file'>
                              {hasPermission(PERMISSION.PROJECT.MEDIA.DELETE.IMPORTED) && <IconButton  
                                disabled = {commonReducer.is_media_loading == true || deleteMediaLoading == true || addFavoriteMediaLoading == true || isBulkDeleting }
                              aria-label={`Remove ${file?.name}`}
                              onClick={()=>removeLinkedFileHandler(file)} sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},
                           }}}>
                                <LinkOffIcon  sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, '& .MuiSvgIcon-root':{
                                  fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},}}}/>
                              </IconButton> }
                         </CustomTooltip>
                             )
                       }
                         
                       {((commonReducer.is_media_loading == true && clickType == 'fvt')|| addFavoriteMediaLoading == true) && fileId == file.id ?(
                              <CircularProgress    
                                sx={{
                                  height:'4px', width:'4px',
                                  margin:{xs:0.75,md:0.87,lg:1.1, xl:1.4},
                                  color:'#666'
                                  }}
                                size={14}
                                loading={(commonReducer.is_media_loading == true && clickType == 'fvt') || addFavoriteMediaLoading == true}
                                disabled
                              >    
                              </CircularProgress>
                             ):(
                           
                          hasPermission(PERMISSION.PROJECT.MEDIA.FAVORITE.IMPORTED) &&  <Checkbox 
                           sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'}},  zIndex:0}} 
                          //  onClick={()=>favoriteHandler(file)} 
                          onChange={(e)=>favoriteHandler(file, e)}
                           inputProps={{'aria-label':`${file?.favourite ? 'Unfavorite' : 'Favorite'} ${file?.name}`}}
                           checked={file?.favourite}  
                           disabled = {commonReducer.is_media_loading == true || deleteMediaLoading == true || addFavoriteMediaLoading == true || isBulkDeleting }
                           icon={<StarOutlineIcon sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'},  '& .MuiSvgIcon-root':{
                            fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},
                           }}}/>} 
                           checkedIcon={<StarIcon sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},
                           } }}/>} 

                           />
                             )}
                           </>
                               }
                               
                          <CustomTooltip title= {processingFailed(file) ? processingFailedText(canReupload) : (file?.video_url == null || file?.video_url == "") ? "Will be available for download after some time" : "Download"} >
                           {hasPermission(PERMISSION.PROJECT.MEDIA.DOWNLOAD.IMPORTED) &&  <IconButton 
                              aria-label={`Download ${file?.name}`}
                              disabled={file?.video_url == null || file?.video_url == "" || commonReducer.is_media_loading == true || deleteMediaLoading == true || addFavoriteMediaLoading == true || isBulkDeleting }  
                              onClick={()=>videoDownloadHandler(file)} 
                              sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'}, 
                                  '& .MuiSvgIcon-root':{fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},}}} 
                            >
                              <FileDownloadOutlinedIcon  sx={{fontSize: {xs:'8px',md:'10px',lg:'13px',xl:'18px'},  '& .MuiSvgIcon-root':{fontSize:{xs:'8px',md:'10px',lg:'13px',xl:'18px'},}}}/>
                            </IconButton>}
                          </CustomTooltip>
                    </Box>
                    </Box>
               </Box>
                ))}

               </AccordionDetails>
          </Accordion>
          )})}

          </>
      }


      <MediaQuickPreview
        open={commonReducer.open_media_preview == true && previewFiles.length > 0}
        files={previewFiles}
        index={previewIndex}
        onClose={previewCloseHandler}
        onNavigate={previewNavigateHandler}
        canDownload={hasPermission(previewScope == 'imported' ? PERMISSION.PROJECT.MEDIA.DOWNLOAD.IMPORTED : PERMISSION.PROJECT.MEDIA.DOWNLOAD.SELF)}
        onDownload={videoDownloadHandler}
        canFavorite={projectEditable && hasPermission(previewScope == 'imported' ? PERMISSION.PROJECT.MEDIA.FAVORITE.IMPORTED : PERMISSION.PROJECT.MEDIA.FAVORITE.SELF)}
        onFavorite={favoriteHandler}
        canRemove={projectEditable && hasPermission(previewScope == 'imported' ? PERMISSION.PROJECT.MEDIA.DELETE.IMPORTED : PERMISSION.PROJECT.MEDIA.DELETE.SELF)}
        removeMode={previewScope == 'imported' ? 'unlink' : 'delete'}
        onRemove={previewScope == 'imported' ? removeLinkedFileHandler : handleDelete}
        actionsDisabled={actionsDisabled}
        isRemoving={isRowDeleting(previewFile, previewScope == 'imported')}
        isFavoriting={isRowFavoriting(previewFile)}
      />

      {bulkDeletePopupOpen && <BulkDeleteMediaPopup
        open={bulkDeletePopupOpen}
        handleClose={bulkDeletePopupCloseHandler}
        selectedCount={selectedFileIds.length}
        bulkDeleteStatus={bulkDeleteStatus}
        bulkDeleteResult={bulkDeleteResult}
        bulkDeleteQueuedBatch={bulkDeleteQueuedBatch}
        bulkDeleteError={bulkDeleteError}
        bulkDeleteFileNames={bulkDeleteFileNames}
        onConfirm={()=>startBulkDelete(selectedFileIds, selectedFiles)}
        onRetry={retryBulkDelete}
      />}
  </Box >
  </Box>
)
}

export default CustomVideoTable
















